import React from 'react';
import PropTypes from 'prop-types';
import { LuCircleCheck, LuFolderKanban } from 'react-icons/lu';
import { LoadingRows } from '../../ProfilePage/components/ProfileUi';
import useTariffText from '../tariffText';

/** Tariffs that already exist for the selected projects (new ones are skipped there). */
const ExistingTariffs = ({ projectIds, projects, projectsWithTariffs, records, loading }) => {
  const { label, typeLabel, formatDate } = useTariffText();
  return (
    <section className="tw-space-y-3 tw-border-t tw-border-slate-200/80 tw-pt-5 dark:tw-border-white/10">
      <h3 className="tw-text-sm tw-font-semibold tw-text-slate-800 dark:tw-text-slate-100">{label('modal.existingTitle')}</h3>
      {loading ? (
        <LoadingRows count={2} height="tw-h-10" label={label('modal.existingLoading')} />
      ) : records && records.length > 0 ? (
        <div className="tw-grid tw-gap-3 lg:tw-grid-cols-2">
          {projectIds.map((projectId) => {
            const project = projects.find((p) => p.id === projectId);
            const projectTariffs = projectsWithTariffs[projectId] || [];
            return (
              <div key={projectId} className="tw-space-y-2 tw-rounded-2xl tw-border tw-border-slate-200/80 tw-p-3 dark:tw-border-white/10">
                <p className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-slate-800 dark:tw-text-slate-100">
                  <LuFolderKanban aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-slate-400" />
                  {project?.titleShort || projectId}
                </p>
                {projectTariffs.length > 0 ? (
                  <ul className="tw-space-y-1.5">
                    {projectTariffs.map((t) => (
                      <li key={t.id} className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-rounded-xl tw-bg-rose-500/[0.05] tw-px-3 tw-py-2 tw-text-xs tw-text-slate-600 dark:tw-text-slate-300">
                        <span className="tw-font-semibold tw-text-slate-800 dark:tw-text-slate-100">{typeLabel(t.type)}</span>
                        <span>{label('modal.recordValue', { value: t.value ?? '-' })}</span>
                        <span className="tw-tabular-nums">{label('modal.recordPrice', { price: t.price ?? 0 })}</span>
                        <span>{label('modal.recordCurrency', { currency: t.currency ?? '-' })}</span>
                        <span>{label('modal.recordDate', { date: t.date ? formatDate(t.date) : '-' })}</span>
                        <span className={`tw-ml-auto tw-rounded-full tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wide ${t.active === false ? 'tw-bg-rose-500/10 tw-text-rose-600 dark:tw-text-rose-300' : 'tw-bg-emerald-500/10 tw-text-emerald-700 dark:tw-text-emerald-300'}`}>
                          {t.active === false ? label('status.passive') : label('status.active')}
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium tw-text-emerald-700 dark:tw-text-emerald-300">
                    <LuCircleCheck aria-hidden="true" className="tw-h-3.5 tw-w-3.5" />
                    {label('modal.noExistingForProject')}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <p className="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400">{label('modal.noExisting')}</p>
      )}
    </section>
  );
};

ExistingTariffs.propTypes = {
  projectIds: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired,
  projectsWithTariffs: PropTypes.object.isRequired,
  records: PropTypes.array,
  loading: PropTypes.bool,
};

export default ExistingTariffs;
